/**
 * Apcam.Api.Web
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ContractStatus = {
    PendingApproval: 1,
    Approved: 2,
    ActionRequired: 3
} as const;
export type ContractStatus = typeof ContractStatus[keyof typeof ContractStatus];

